var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "72mm",
    height: "72mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 7200 7200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5296 3962c-213,-132 -442,-240 -684,-320l-83 -28 76 -43c62,-35 121,-74 178,-117l0 0c56,-43 110,-90 160,-140l0 0c144,-145 261,-317 341,-508 76,-184 118,-386 118,-597l0 -283c0,-211 -42,-412 -118,-596 -80,-191 -197,-364 -341,-508l0 0c-144,-145 -317,-261 -508,-341 -184,-76 -385,-119 -596,-119l-493 0c-211,0 -413,43 -597,119 -191,80 -363,196 -508,341 -144,144 -261,317 -340,508 -77,184 -119,385 -119,596l0 283c0,211 42,413 119,597 79,191 196,363 340,508 51,50 104,97 161,140l0 0c56,43 116,82 177,117l77 43 -84 28c-241,80 -471,188 -684,320 -216,134 -416,293 -595,471 -300,301 -543,660 -708,1058 -159,383 -248,802 -248,1241l0 14 0 214 214 0 6082 0 214 0 0 -214 0 -14c0,-439 -88,-858 -247,-1241 -166,-398 -408,-757 -709,-1058 -179,-179 -379,-337 -595,-471zm-1950 -3172l493 0c153,0 299,31 433,87 138,57 264,142 369,247 104,105 189,230 247,369 56,134 86,280 86,433l0 283c0,153 -30,300 -86,433 -58,139 -143,264 -247,369 -105,105 -231,190 -369,248 -134,55 -280,86 -433,86l-493 0c-153,0 -300,-31 -433,-86 -139,-58 -264,-143 -369,-248l0 0c-105,-105 -190,-230 -248,-369 -55,-133 -86,-280 -86,-433l0 -283c0,-153 31,-299 86,-433 58,-139 143,-264 248,-369l0 0c105,-105 230,-190 369,-247 133,-56 280,-87 433,-87zm1324 3330c346,144 657,355 919,616 232,233 425,506 566,807 137,293 225,612 254,947l4 43 -43 0 -5555 0 -43 0 4 -43c28,-335 117,-654 253,-947 141,-301 334,-574 567,-807 261,-261 573,-472 918,-616 333,-138 697,-215 1078,-215 381,0 745,77 1078,215z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.370602186fa44c3bdda301573bd7fcbd.svg";
export { ForwardRef as ReactComponent };